<template>
  <transition
    enter-active-class="transition-opacity duration-200"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-150"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="hasTyping"
      class="inline-flex items-center px-3 py-3 text-sm text-gray-500"
    >
      <div class="flex flex-none mr-2 -space-x-3">
        <div
          v-for="(_, index) in typingUsers.slice(0, 3)"
          :key="index"
          class="flex-none w-6 h-6 overflow-hidden bg-gray-100 border-2 border-white rounded-full"
        >
          <img :src="avatarImage" class="object-cover w-full h-full" />
        </div>

        <div
          v-if="typingUsers.length > 3"
          class="flex items-center justify-center flex-none w-6 h-6 font-bold bg-gray-300 border-2 border-white rounded-full"
          style="font-size: 0.6rem"
        >
          +{{ typingUsers.length - 3 }}
        </div>
      </div>

      <span v-if="typingText" class="whitespace-nowrap">
        {{ typingText }}
        <span class="dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </span>
    </div>
  </transition>
</template>

<script>
import { image } from "@/common/config";
import { mapGetters } from "vuex";

export default {
  name: "TypingIndicator",

  props: {
    threadId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters(["typingUserListByThread", "hasTypingActivityByThread"]),

    typingUsers() {
      return this.typingUserListByThread(this.threadId);
    },

    hasTyping() {
      return this.hasTypingActivityByThread(this.threadId);
    },

    typingText() {
      const names = this.typingUsers;
      const count = names.length;
      if (!count) return "";
      if (count === 1) return `${names[0]} is typing`;
      if (count === 2) return `${names[0]} and ${names[1]} are typing`;
      return `${names[0]} and ${count - 1} others are typing`;
    },

    avatarImage() {
      return image.customer;
    },
  },

  watch: {
    typingUsers(val) {
      if (val.length) {
        this.$emit("typing-visible");
      }
    },
  },
};
</script>

<style scoped>
.dots {
  display: inline-flex;
  gap: 0;
}

.dots span {
  opacity: 0;
  animation: blink 1.4s infinite;
}

.dots span:nth-child(1) {
  animation-delay: 0s;
}

.dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
